import {html} from '@isceco/widget-library2/external/lit'
import WebComponent from '../../../WebComponent.js'
import GPService from '../../Geschaeftspartner/GPService'
import BerechtigungUtil from '../../../services/BerechtigungUtil'
import Navigation from '../../Navigation/Navigation'
import KontingentService from "../../../services/KontingentService";

import '../../../components/Tile/Tile'
import '../../../components/Tile/TileGroup'

export default class GPDashboard extends WebComponent {

  constructor() {
    super()
    this.gpService = new GPService()
    this.kontingentService = new KontingentService()
    this.gpId = new BerechtigungUtil().getActiveProfile().gpExtId
  }

  get translationFile() {
    return './views/Dashboard/GP/i18n.json'
  }

  connectedCallback() {
    super.connectedCallback()
    this.reload()
  }

  reload() {
    Promise.all([
      this.gpService.read(this.gpId),
      this.kontingentService.search(null, [
        ['status', 'VERSENDET_ELEKTRONISCH'],
        ['status', 'VORBEREITET_POSTALISCH'],
        ['status', 'VERSENDET_POSTALISCH'],
        ['sort', 'start'],
        ['order', 'asc']
      ])
    ]).then(([_, kontingente]) => {
      this.kontingente = kontingente
    }).catch(() => {
      navigate({to: Navigation.ROUTES.gpVerfuegungSetup.url, allow: true})
    }).finally(() =>
      this.render()
    )
  }

  getTemplate() {
    return html`
      <isceco-title id="page-title" text="${this.i18n.translate('dashboard.gp.title')}">
      </isceco-title>
      ${this.kontingente?.map(this._getKontingentTemplate)}
    `
  }

  _getKontingentTemplate = kontingent => {
    const title = kontingent.periode.start < new Date() ? 'dashboard.gp.kontingentierung.periode.laufend' : 'dashboard.gp.kontingentierung.periode.naechste'
    return html`
      <isceco-title size="small" text="${this.i18n.translate(title, {date: formatDate(kontingent.periode.start)})}">
      </isceco-title>
      <eko-tile-group>
        <eko-tile text="${this.i18n.translate('dashboard.gp.kachel.verfuegung.pendent.text')}"
                  description="${this.i18n.translate('dashboard.gp.kachel.verfuegung.pendent.description')}"
                  .count="${kontingent.neu}" @click="${() => this._downloadPdf(kontingent)}">
          <i class="huge icons" slot="icon">
            <i class="file outline icon"></i>
            <i class="blue bottom left corner arrow down icon"></i>
          </i>
        </eko-tile>
      </eko-tile-group>
    `
  }

  _downloadPdf = kontingent => {
    const filename = `${kontingent.geschaeftspartner.name} - ${formatDate(kontingent.periode.start)}`
    this.kontingentService.read(kontingent.id, 'pdf')
      .then(response => response.blob())
      .then(blob => download(toValidFilename(filename, 'pdf'), blob))
      .then(() => this.reload())
  }
}
customElements.define('eko-frontend-gp-dashboard', GPDashboard)
